// Fechas de calendario que el dashboard manda al backend (H64).
//
// `toISOString()` convierte a UTC: en Ecuador (UTC-5), a partir de las 19:00 da la fecha del
// día siguiente, y un filtro «hasta hoy» dejaba fuera lo de la noche. Para una fecha de
// calendario (filtros, «al día», rangos) se usa la fecha LOCAL; un instante se sigue mandando
// con toISOString().

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;

/** «YYYY-MM-DD» de la fecha local del navegador, o null si no hay fecha válida. */
export function localISODate(date) {
    if (date === null || date === undefined || date === '') return null;
    // Una fecha ya en «YYYY-MM-DD» se respeta: new Date('2026-10-12') la tomaría como UTC.
    if (typeof date === 'string' && ISO_DATE.test(date)) return date;
    const d = date instanceof Date ? date : new Date(date);
    if (isNaN(d.getTime())) return null;
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${d.getFullYear()}-${month}-${day}`;
}

/** La fecha local de un «YYYY-MM-DD» (lo inverso de localISODate), o null si no lo es. */
export function fromLocalISODate(value) {
    if (typeof value !== 'string' || !ISO_DATE.test(value)) return null;
    const [year, month, day] = value.split('-').map(Number);
    return new Date(year, month - 1, day);
}

/** 00:00:00.000 local del día de `date`: el instante con que empieza ese día de calendario. */
export function startOfLocalDay(date) {
    if (!date) return null;
    const d = date instanceof Date ? date : new Date(date);
    if (isNaN(d.getTime())) return null;
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
}

/** 23:59:59.999 local del día de `date`: un rango «hasta este día» lo incluye completo. */
export function endOfLocalDay(date) {
    if (!date) return null;
    const d = date instanceof Date ? date : new Date(date);
    if (isNaN(d.getTime())) return null;
    return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59, 999);
}

/** Primer día del mes de `date` (hoy por defecto), a medianoche local. */
export function firstDayOfMonth(date = new Date()) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
}
